module.exports = __webpack_public_path__ + "img/sheet_person.150aed40.svg";